import axios from 'axios';

const api = axios.create({
    baseURL: 'http://34.237.145.9:5001/api/'
})

export default api;